import React, { createContext, useEffect, useState } from 'react'

import { connect } from 'react-redux'
import { getUser } from '../reducers/UserReducer'
import { getStudentFreeFields } from '../utils/api/student'

const mapStateToProps = state => {
  return {
    user: getUser(state.getUser)
  }
}

export const StudentContext = createContext()

const StudentProvider = ({ children, user }) => {
  const [freefields, setFreefields] = useState({})

  useEffect(() => {
    if (user.student) {
      getStudentFreeFields(user.student, user, { contexts: ['institution'] }).then(json => {
        if (json?.data) {
          const freefields = {}

          json.data.forEach(sff => {
            if (!freefields[sff.fieldType.institution.id]) {
              freefields[sff.fieldType.institution.id] = []
            }

            freefields[sff.fieldType.institution.id].push(sff)
          })

          setFreefields(freefields)
        }
      })
    } else {
      setFreefields({})
    }
  }, [user.student])

  return (
    <StudentContext.Provider
      value={{ freefields }}
    >
      {children}
    </StudentContext.Provider>
  )
}

export default connect(mapStateToProps)(StudentProvider)
